<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <promo-code-table />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import PromoCodeTable from './PromoCodeTable'

  export default {
    name: 'promo-code-view',
    components: {PromoCodeTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/promotion/promoCode/PromoCode.vue